var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMozLogoBwRgb = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.8 12.6 2.6 13h1l2.6-13h7.8v20.6h-4.2v-17h-1l-3.7 17H9l-3.7-17h-1v17H0V12.6h7.8ZM32 16.9c5 0 7.8 3 7.8 8.3 0 5.4-2.9 8.3-7.8 8.3s-7.7-3-7.7-8.3c0-5.4 2.8-8.3 7.7-8.3Zm0 13.3c2.2 0 3.3-1.2 3.3-3.8V24c0-2.6-1-3.8-3.3-3.8-2.2 0-3.2 1.2-3.2 3.8v2.4c0 2.6 1 3.8 3.2 3.8Zm9.5-.1 8.1-9.8h-8v-3h13v3l-8 9.8h8.2v3H41.6v-3Zm15.5-12.9h6v16h-4.3V20.3h-1.7v-3Zm1.7-4.6h4.3v3h-4.3v-3Zm7 0h6v20.6h-4.2V15.6H66v-3Zm8.9 0h6v20.6h-4.3V15.6h-1.7v-3Zm15 4.3c2.4 0 4 1.2 4.4 3.2h1v-2.9h5v3.1h-1.7v9.8h1.7v3h-2.4c-1.7 0-2.6-.8-2.6-2.6v-.2h-1c-.4 2-2 3.2-4.3 3.2-3.8 0-6.4-3.2-6.4-8.3 0-5.1 2.6-8.3 6.4-8.3ZM91 30.2c2.2 0 3.1-1.2 3.1-3.8V24c0-2.6-1-3.8-3-3.8-2.2 0-3.2 1.2-3.2 3.8v2.4c0 2.6 1 3.8 3.1 3.8ZM116 33.2h-4.3V0h4.2v33.2Zm3.4-16.3h16.8v-1l-11-3.9V8.6l11-4v-.9h-13V0H140v6.8l-9 3v1l9 3v6.8h-20.6V17Zm0-13.2h3.8v3.8h-3.8V3.7Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h140v33.5H0z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMozLogoBwRgb);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/moz-logo-bw-rgb.af4ff126cf0c81ef136dc2542f4a5e30.svg";